module.exports = __webpack_public_path__ + "static/media/ProaxiomLogo.8afaebf9.png";